var map = {
	"./colors/index.vue": "Xjtk",
	"./colors/palette/index.vue": "S01/",
	"./components/index.vue": "u0y/",
	"./introduction/get-started/index.vue": "/nPV",
	"./introduction/index.vue": "0WKx"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(7).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "qqer";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./docs lazy-once ^\.\/.*\/index\.vue$
// module id = qqer
// module chunks = 12